import {
  RiArrowDownSLine,
  RiArrowRightSLine,
  RiArrowUpSLine,
} from "react-icons/ri";
import TableModeOfRequirement from "./TableModeOfRequirement";
import { useEffect, useState } from "react";

export default function ModeOfRequirement({ setData }) {
  const [tableModeOfRequirementData, setTableModeOfRequirementData] = useState([
    {
      id: 1,
      name: "Online Interview",
      description: "Description",
    },
    {
      id: 2,
      name: "Client Interview",
      description: "Description",
    },
  ]);
  const [show, setShow] = useState(false);

  const updateMOR = (updatedMOR) => {
    setTableModeOfRequirementData(updatedMOR);
  };

  useEffect(() => {
    const copiedData = [...tableModeOfRequirementData];
    const newData = [];
    copiedData.forEach((item) => {
      newData.push({ name: item?.name, description: item?.description });
    });
    setData((prev) => ({
      ...prev,
      mode_of_recruitment: newData,
    }));
  }, [tableModeOfRequirementData]);

  return (
    <div className="flex flex-wrap  gap-4 ">
      <div className="max-w-sm min-w-max  w-full flex gap-3 items-center h-fit">
        <button
          className="p-1 rounded-md ring-1 ring-slate-200"
          onClick={() => setShow((p) => !p)}
          type="button"
        >
          {show ? (
            <RiArrowDownSLine size={"1.4rem"} />
          ) : (
            <RiArrowRightSLine size={"1.4rem"} />
          )}
        </button>
        <div>
          <h2 className="font-semibold">Mode of recruitment</h2>
          <p>Provide Mode of recruitment.</p>
        </div>
      </div>
      <div
        className={`w-full m-2  px-4 rounded-md transition-all  ${
          show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
        }`}
      >
        <button
          type="button"
          onClick={() => {
            const newRow = {
              description: "",
              name: "",
              id: Math.floor(Math.random() * 10000),
            };

            const CurrentTableModeOfRequirementData = [
              ...tableModeOfRequirementData,
            ];
            CurrentTableModeOfRequirementData.push(newRow);
            setTableModeOfRequirementData(CurrentTableModeOfRequirementData);
          }}
          className="bg-red text-white p-2 rounded-md mt-2 ml-2"
        >
          + Add Another
        </button>
        <TableModeOfRequirement
          tableModeOfRequirementData={tableModeOfRequirementData}
          setTableModeOfRequirementData={setTableModeOfRequirementData}
          updateMOR={updateMOR}
        />
      </div>
    </div>
  );
}
